import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  position: relative;
  margin-bottom: 16px;

  ${({ theme }) => theme.isTablet`
    width: calc(50% - 7px);
    margin-bottom: 0;
  `}
  > gmp-place-autocomplete,
  > input {
    line-height: 16px;
    background: ${props => props.theme.rtColors.black100};
    border: none;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;
  }
  > input {
    padding: 16px 52px;
  }
  > gmp-place-autocomplete {
    &::part(input) {
      padding: 16px 0 16px 52px;
      border-radius: 8px;
      background: ${props => props.theme.rtColors.black100};
    }
  }
`;

const HalfWidthSearchContainer = ({ children }) => (
  <Container>{children}</Container>
);

HalfWidthSearchContainer.propTypes = {
  children: PropTypes.node,
};

export default HalfWidthSearchContainer;
